module.exports = __webpack_public_path__ + "media/2_2-8.96675a5e.mp3";